import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyC = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.86515 16C1.03658 16 0.104004 15.0852 0.104004 13.2739V2.71698C0.104004 0.914808 1.03658 0 2.86515 0H13.352C15.1806 0 16.104 0.914808 16.104 2.71698V13.2739C16.104 15.0852 15.1806 16 13.352 16H2.86515ZM2.91086 14.5089H13.2971C14.1383 14.5089 14.6137 14.0606 14.6137 13.1824V2.81761C14.6137 1.93939 14.1383 1.49114 13.2971 1.49114H2.91086C2.06972 1.49114 1.60343 1.93939 1.60343 2.81761V13.1824C1.60343 14.0606 2.06972 14.5089 2.91086 14.5089ZM8.11315 12.0389C5.85486 12.0389 4.42858 10.438 4.42858 7.91309C4.42858 5.39737 5.864 3.77816 8.11315 3.77816C9.64 3.77816 10.8651 4.51001 11.2857 5.67181C11.3497 5.82733 11.368 5.93711 11.368 6.08348C11.368 6.4677 11.1211 6.70555 10.7371 6.70555C10.4537 6.70555 10.2709 6.57747 10.1246 6.26644C9.78629 5.44311 9.08229 4.99485 8.13143 4.99485C6.79658 4.99485 5.90972 6.16581 5.90972 7.91309C5.90972 9.66038 6.79658 10.8313 8.13143 10.8313C9.08229 10.8313 9.77715 10.3739 10.1246 9.55975C10.2709 9.24871 10.4537 9.12064 10.7371 9.12064C11.1211 9.12064 11.368 9.35849 11.368 9.74271C11.368 9.87993 11.3497 9.99886 11.2857 10.1544C10.8651 11.3162 9.64915 12.0389 8.11315 12.0389Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
